<template lang="pug">
    div
        v-select(
            class="style-chooser"
            :options="options" 
            :multiple="multiple"
            :placeholder="$t('home.selectOriginText')"
             @search="getOptionsDebounce"
            :filterable="false"
            :value="$store.state.dashboard.queryFilter.originHosts"
            @input="updateValue"
        )
            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import { _debounce, isSameJson } from "@/libs/utils";
export default {
    name: "OriginSelector",
    components: {},
    props: {
        multiple: { type: Boolean, default: true }
    },
    watch: {
        groupNames: function(newVal, oldVal) {
            // console.log(`groupNames changed from ${oldVal} to ${newVal}`);
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "originHosts", value: [] });
                this.getOptions();
            }
        },
        serviceGroupNames: function(newVal, oldVal) {
            // console.log(`serviceGroupNames changed from ${oldVal} to ${newVal}`);
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "originHosts", value: [] });
                this.getOptions();
            }
        },
        appProfileNames: function(newVal, oldVal) {
            // console.log(`appProfileNames changed from ${oldVal} to ${newVal}`);
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "originHosts", value: [] });
                this.getOptions();
            }
        },
        serverNames: function(newVal, oldVal) {
            // console.log(`serverNames changed from ${oldVal} to ${newVal}`);
            // console.log(Array.isArray(newVal));
            // console.log(newVal.length);
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "originHosts", value: [] });
                this.getOptions();
            }
        }
    },
    data() {
        return {
            options: []
        };
    },
    computed: {
        groupNames() {
            let groupNames = this.$store.state.dashboard.queryFilter.groupNames;
            return groupNames.length > 0 ? groupNames : "*";
        },
        serviceGroupNames() {
            let serviceGroupNames = this.$store.state.dashboard.queryFilter.serviceGroupNames;
            return serviceGroupNames.length > 0 ? serviceGroupNames : "*";
        },
        appProfileNames() {
            let appProfileNames = this.$store.state.dashboard.queryFilter.appProfileNames;
            return appProfileNames.length > 0 ? appProfileNames : "*";
        },
        serverNames() {
            let serverNames = this.$store.state.dashboard.queryFilter.serverNames;
            return serverNames.length > 0 ? serverNames : "*";
        },
        getOptionsQueryString() {
            let searchParams = {};
            searchParams.groupNames = this.groupNames;
            searchParams.serviceGroupNames = this.serviceGroupNames;
            searchParams.appProfileNames = this.appProfileNames;
            searchParams.serverNames = this.serverNames;
            return new URLSearchParams(searchParams).toString();
        }
    },
    methods: {
        getOptions() {
            getFormOptions(`origins?${this.getOptionsQueryString}`).then(res => {
                this.options = res.data.options;
            });
        },
        updateValue(value) {
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "originHosts", value: value });
        }
    },
    mounted() {
        this.getOptions();
    },
    created() {
        var self = this;
        this.getOptionsDebounce = _debounce(function(queryValue, loading) {
            loading(true);
            queryValue = queryValue || "";
            getFormOptions(`groupby/origins?&origins=*${queryValue}*&${self.getOptionsQueryString}`).then(res => {
                self.options = res.data.options;
                loading(false);
            });
        });
    },
    destroyed() {},
    beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/OriginSelector.vue